<template>
  <div class="alertDoc">
    <documentation-container :title="title">
      <template slot="content">
        <grid-card :min="280" :column="`auto-fill`" :gap="10">
          <template slot="item">
            <alert v-for="(alert, index) in alerts" :key="index" :title="alert.title" :content="alert.content" :type="alert.type" :group="'saved'" />
          </template>
        </grid-card>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import Alert from '@/components/Alert'
import DocumentationContainer from '@/components/DocumentationContainer'
import GridCard from '@/components/Grid/Card'

export default {
  name: 'adx-alert-doc',
  components: {
    'documentation-container': DocumentationContainer,
    'grid-card': GridCard,
    'alert': Alert,
  },
  data(){
    return {
      title: 'Alert',
      alerts: [
        {
          title: 'primary-alert heading',
          content: 'class primary-alert text goes here',
          type: 'primary'
        },
        {
          title: 'danger-alert heading',
          content: 'class danger-alert text goes here',
          type: 'danger'
        },
        {
          title: 'success-alert heading',
          content: 'class success-alert text goes here',
          type: 'success'
        },
        {
          title: 'secondary-alert heading',
          content: 'class secondary-alert text goes here',
          type: 'secondary'
        },
        {
          title: 'warning-alert heading',
          content: 'class warning-alert text goes here',
          type: 'warning'
        },
        {
          title: 'teal-alert heading',
          content: 'class teal-alert text goes here',
          type: 'teal'
        }
      ]
    }
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>